import React from 'react';
import {
    Grid,
    TextField,
    InputAdornment,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Box,
    FormHelperText
} from '@mui/material';
import { Briefcase, Award } from 'lucide-react';
import { StepProps } from './TypeCadEscriComponents';
import { cpf, cnpj } from '../../../components/Inputs/masks';

const ProfessionalInfoStep: React.FC<StepProps> = ({ formik, activeStep }) => {
    if (activeStep !== 1) return null;

    return (
        <Box sx={{ mt: 2 }}>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                    <FormControl
                        fullWidth
                        error={formik.touched.tipopessoa && Boolean(formik.errors.tipopessoa)}
                    >
                        <InputLabel id="person-type-label">Tipo de Pessoa</InputLabel>
                        <Select
                            labelId="person-type-label"
                            id="tipopessoa"
                            name="tipopessoa"
                            value={formik.values.tipopessoa}
                            label="Tipo de Pessoa"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            startAdornment={
                                <InputAdornment position="start">
                                    <Award size={20} />
                                </InputAdornment>
                            }
                        >
                            <MenuItem value="fisica">Pessoa Física</MenuItem>
                            <MenuItem value="juridica">Pessoa Jurídica</MenuItem>
                        </Select>
                        {formik.touched.tipopessoa && formik.errors.tipopessoa && (
                            <FormHelperText>{formik.errors.tipopessoa}</FormHelperText>
                        )}
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField
                        fullWidth
                        id="cnpj_escritorio"
                        name="cnpj_escritorio"
                        label={formik.values.tipopessoa === 'fisica' ? "CPF" : "CNPJ"}
                        value={formik.values.cnpj_escritorio}
                        onChange={e => {
                            const val = formik.values.tipopessoa === 'fisica' ? cpf(e.target.value) : cnpj(e.target.value);
                            formik.setFieldValue('cnpj_escritorio', val);
                        }}
                        onBlur={formik.handleBlur}
                        error={formik.touched.cnpj_escritorio && Boolean(formik.errors.cnpj_escritorio)}
                        helperText={formik.touched.cnpj_escritorio && formik.errors.cnpj_escritorio}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <Briefcase size={20} />
                                </InputAdornment>
                            ),
                            inputProps: { min: 0 }
                        }}
                    />
                </Grid>
                {formik.values.tipopessoa === 'juridica' && (
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            id="razao_social_escritorio"
                            name="razao_social_escritorio"
                            label="Razão Social do Escritorio"
                            value={formik.values.razao_social_escritorio}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.touched.razao_social_escritorio && Boolean(formik.errors.razao_social_escritorio)}
                            helperText={formik.touched.razao_social_escritorio && formik.errors.razao_social_escritorio}
                        />
                    </Grid>
                )}
                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        id="nome_escritorio"
                        name="nome_escritorio"
                        label="Nome Fantasia do Escritorio"
                        value={formik.values.nome_escritorio}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.nome_escritorio && Boolean(formik.errors.nome_escritorio)}
                        helperText={formik.touched.nome_escritorio && formik.errors.nome_escritorio}
                    />
                </Grid>
            </Grid>
        </Box>
    );
};

export default ProfessionalInfoStep;